import initSwiper from './Library';

initSwiper();
